import { parseLocalDateTime } from '~/shared/utils/parseLocalDateTime';

export function formatTime(isoString: string): string {
  const dt = parseLocalDateTime(isoString);
  const hours = String(dt.hour).padStart(2, '0');
  const minutes = String(dt.minute).padStart(2, '0');
  return `${hours}:${minutes}`;
}
